import request from './request.js';
import {requestbody} from './request.js'

export async function sy_comapny(params = {}) {
    return await requestbody('sys/queryCompanyList', 'post', params)
}

//本期报税进度统计
export async function sy_statistics_head_data (params = {
}) {
    return await request('/statistics/statisticsHeadData', 'post', params)
}

//本期报税进度统计
export async function sy_statistics_price_head (params = {
}) {
    return await request('/statistics/statisticsPriceHead', 'post', params)
}

//本期报税进度统计
export async function sy_statistics_gswdswqkb (params = {
}) {
    return await request('/statistics/statisticsGSWDSWQKB', 'post', params)
}

//本期报税进度统计
export async function sy_statistics_gswdzsjzqkb (params = {
}) {
    return await request('/statistics/statisticsGSWDZSJZQKB', 'post', params)
}

//本期报税进度统计
export async function sy_statistics_szwdsezbqkb (params = {
}) {
    return await request('/statistics/statisticsSZWDSEZBQKB', 'post', params)
}

//本期报税进度统计
export async function sy_statistics_sfqk (params = {
}) {
    return await request('/statistics/statisticsSFQK', 'post', params)
}

//本期报税进度统计
export async function sy_statistics_xmwdzsjzqkb (params = {
}) {
    return await request('/statistics/statisticsXMWDZSJZQKB', 'post', params)
}

//本期报税进度统计
export async function sy_statistics_ssdyhcpcqkb (params = {
}) {
    return await request('/statistics/statisticsSSDYHCPCQKB', 'post', params)
}